import { Component, DestroyRef, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  ButtonDirective,
  NewWcgSwitchComponent,
  WcgDialogModule,
} from '@wcg/frontend-framework';
import { MatButtonModule } from '@angular/material/button';
import { irbPriorityDialogData, irbPriorityTypes } from '../../models';
import { Store } from '@ngrx/store';
import { irbPriorityChange } from '../../redux';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SUBMISSION_HEADER_ACTIONS } from '@data-access/submissions/actions/submissions.actions';

@Component({
  imports: [
    FormsModule,
    MatDialogModule,
    WcgDialogModule,
    MatButtonModule,
    ButtonDirective,
    NewWcgSwitchComponent,
  ],
  selector: 'wcg-priority-dialog',
  styleUrl: './priority-dialog.component.css',
  templateUrl: './priority-dialog.component.html',
})
export class PriorityDialogComponent {
  public dialogRef = inject(MatDialogRef<PriorityDialogComponent>);
  public data: irbPriorityDialogData = inject(MAT_DIALOG_DATA);
  private readonly _store = inject(Store);
  private readonly _storeActions$ = inject(Actions);
  private readonly _destroyRef = inject(DestroyRef);

  irbLabel = signal<boolean>(this.data.priority);

  constructor() {
    this._customListeners();
  }

  handleChange() {
    this.irbLabel.update((irb) => !irb);
  }

  save() {
    const priorityData: irbPriorityTypes = {
      priority: this.irbLabel() ? 'IRB+' : 'Normal',
      rush_comments: null,
      rush_date: null,
    };

    // Dispatch an action to call the API via an effect
    this._store.dispatch(
      irbPriorityChange({
        workspaceId: this.data.workspaceId,
        priority: priorityData,
      }),
    );
  }

  private _customListeners() {
    this._storeActions$
      .pipe(
        ofType(SUBMISSION_HEADER_ACTIONS.updateIRBPlusSuccess),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe({
        next: () => this.dialogRef.close(),
      });
  }
}
